import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';
import ModalComponent from '../math_view/components_parts/ModalComponent';
import HelpGraphButton from "./HelpGraphButton";

const ButtonToolbarComponent = ({
  clearGraphSelection,
  exportState,
  setExerciseNameState,
  modalShowState,
  diagramToggledState,
  teacherModeState,
  setDiagramToggledState,
  setModelShowState,
  importState,
  setTeacherModeState
}) => /*#__PURE__*/React.createElement(ButtonToolbar, null, /*#__PURE__*/React.createElement(ButtonGroup, {
  className: "mr-2"
}, /*#__PURE__*/React.createElement(Button, {
  variant: "outline-primary",
  title: "Switch to set view",
  className: diagramToggledState ? '' : ' active',
  onClick: () => {
    setDiagramToggledState(false);
  }
}, /*#__PURE__*/React.createElement("strong", null, "{\xA0}"), /*#__PURE__*/React.createElement("span", {
  className: "d-none d-sm-inline"
}, "\xA0Sets")), /*#__PURE__*/React.createElement(Button, {
  variant: "outline-primary",
  title: "Switch to graph view",
  className: diagramToggledState ? ' active' : '',
  onClick: () => setDiagramToggledState(true)
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-project-diagram"
}), /*#__PURE__*/React.createElement("span", {
  className: "d-none d-sm-inline"
}, "\xA0Graph"))), /*#__PURE__*/React.createElement(ButtonGroup, {
  className: "mr-2"
}, /*#__PURE__*/React.createElement(Button, {
  size: "md",
  variant: "secondary",
  title: "Export this exercise",
  onClick: () => {
    setModelShowState(true);
    clearGraphSelection();
  }
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-file-export"
}), /*#__PURE__*/React.createElement("span", {
  className: "d-none d-sm-inline"
}, "\xA0Export")), /*#__PURE__*/React.createElement(Button, {
  variant: "secondary",
  title: "Import an exercise",
  onClick: () => document.getElementById('uploadInput').click()
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-file-import"
}), /*#__PURE__*/React.createElement("input", {
  id: "uploadInput",
  type: "file",
  name: "jsonFile",
  onChange: e => {
    importState(e);
  },
  hidden: true,
  style: {
    display: 'none'
  }
}), /*#__PURE__*/React.createElement("span", {
  className: "d-none d-sm-inline"
}, "\xA0Import"))), diagramToggledState ? /*#__PURE__*/React.createElement(ButtonGroup, {
  className: "mr-2"
}, /*#__PURE__*/React.createElement(HelpGraphButton, null)) : null, /*#__PURE__*/React.createElement(ModalComponent, {
  exportState: exportState,
  modalShowState: modalShowState,
  setExerciseNameState: setExerciseNameState,
  setModalShowState: setModelShowState
}));

export default ButtonToolbarComponent;